import { render } from "./ServicesDatatableTDComplexServiceTitle.vue?vue&type=template&id=18a14c1c"
import script from "./ServicesDatatableTDComplexServiceTitle.vue?vue&type=script&lang=js"
export * from "./ServicesDatatableTDComplexServiceTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__